import { css } from 'styled-components';

// Consumers add their own layout, sizing and overflow handling on top.
export const contentBlockSurface = css`
  // border: 1px solid ${({ theme }) => theme.palette.grey[400]};
  background: ${({ theme }) => theme.palette.background.default};
  border-radius: ${({ theme }) => theme.spacing(4)};
  box-shadow: ${({ theme }) => theme.shadowBox.contentBlock};
`;
